
import { 
    GET_CASES,
    GET_CASES_SUCCESS,
    GET_CASES_FAIL, 
    GET_CASES_RESET,
} from "../actions/getCasesAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getCasesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CASES:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_CASES_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_CASES_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_CASES_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getCasesReducer;
